import { Lock, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const isPremium = (user) =>
    user?.subscription_tier === "premium" &&
    ["active", "trialing", "past_due"].includes(user?.subscription_status);

/**
 * PremiumGate — wraps premium-only UI. Non-premium users see a beautiful
 * "Cultivate Deeper" card in the same footprint.
 */
export const PremiumGate = ({ children, title = "Cultivate deeper", copy, className = "", cta = "See Premium", testid }) => {
    const { user } = useAuth();
    if (isPremium(user)) return children;

    return (
        <div
            className={`hairline rounded-lg p-10 md:p-14 relative overflow-hidden ${className}`}
            data-testid={testid || "premium-gate"}
        >
            <div className="absolute -right-8 -top-8 opacity-[0.06] pointer-events-none">
                <Sparkles className="w-64 h-64 text-[hsl(var(--eden-gold))]" strokeWidth={0.3} />
            </div>
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.4em] text-[hsl(var(--eden-gold))] mb-6">
                <Lock className="w-3 h-3" strokeWidth={1.5} /> Premium
            </div>
            <h3 className="font-serif text-3xl md:text-4xl leading-[1.05] max-w-2xl">{title}</h3>
            {copy && <p className="mt-4 text-muted-foreground max-w-xl leading-relaxed">{copy}</p>}
            <div className="mt-8">
                <Link to="/membership">
                    <Button className="bg-[hsl(var(--eden-forest))] text-[hsl(var(--eden-cream))] hover:bg-[hsl(var(--eden-forest))]/90 rounded-md h-11 px-6 text-xs uppercase tracking-[0.3em]">
                        {cta}
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default PremiumGate;
